import React from 'react'
import { Link, NavLink } from 'react-router-dom'

import { getEnv } from 'Core/env'

const env = getEnv()
const externalPathDomain = env.REACT_APP_V1_URL

export const generateLabel = ({
	name,
	path,
	onClick,
	externalPath,
	isLogout
}: {
	name: string
	path?: string
	onClick?: () => void
	externalPath?: string
	isLogout?: boolean
}): React.ReactNode => {
	if (isLogout) {
		return (
			<Link to="" onClick={onClick}>
				{name}
			</Link>
		)
	}

	if (externalPath) {
		return (
			<Link to={{ pathname: `${externalPathDomain}${externalPath}` }} target="_blank">
				{name}
			</Link>
		)
	}

	if (path) {
		return <NavLink to={path}>{name}</NavLink>
	}

	return <>{name}</>
}
